import React from 'react';
import { Formik, Field, Form } from 'formik';
import Box from '@mui/material/Box';
import Button from '@mui/lab/LoadingButton';
import { useDispatch, useSelector } from 'react-redux';

import useAuthHook from '@giro/shared-hooks/useAuth.hook';

import PDVLayout from '../layouts/Slip.layout';

import { useFormikContext } from 'formik';
import { useHistory } from 'react-router-dom';
import DatePicker from 'react-datepicker';

import ScreenLayout from '@giro-pdv/layouts/Screen.layout';
import { v4 } from 'uuid';
import { flow, isEqual } from 'lodash';
import * as yup from 'yup';
import { Dialog, Paper, Typography } from '@mui/material';
import { DateRange } from 'react-date-range';
import billets from '../store/create';
import useFetchHook from '@giro-pdv/hooks/useFetch.hook';
import TextFieldLabel from '@giro-pdv/components/TextFieldLabel.component';
import format from 'date-fns/format';
import FieldLabelFormik from '@giro-pdv/components/FieldLabelFormik.component';
import { ptBR } from 'date-fns/locale';

import fetch from '@giro/shared-utils/fetch.util';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import SlipLayout from '@giro-pdv/modules/slips/layouts/Slip.layout';
import FieldLabelFormikComponent from '@giro-pdv/components/FieldLabelFormik.component';
import FieldPhoneComponent from '@giro/shared-components/Fields/FieldPhone.component';
import FieldDocumentComponent from '@giro/shared-components/Fields/FieldDocument.component';
import TextFieldLabelComponent from '@giro-pdv/components/TextFieldLabel.component';
import { FieldCurrencyComponentDigits } from '@giro/shared-components/Fields/FieldCurrency.component';
import dialogSendSlip from '../store/dialogs/dialogSendSlip';

const maskConveniado =
  '#####.##### #####.###### #####.###### # ###############';

const maskTribute = '###########-# ###########-# ###########-# ###########-#';

const states = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

const TYPES = {
  PLACARENAVAM: 0,
  RENAVAM: 1,
  DOCUMENTO: 2,
};

const FormBillet = () => {
  const { user } = useAuthHook();

  const dispatch = useDispatch();

  const dispatchRedux = {
    billetServicePost: flow(billets.action.servicePost, dispatch),
    OPEN_SEND: flow(dialogSendSlip.action.open, dispatch),
  };

  const selectorRedux = {
    loading: useSelector(billets.selector.selectLoading),
  };

  const isBlockedSelect = user?.user?.codes?.idRole === 6;

  const disabled = false;

  const validationSchema = yup.object({
    referencia_externa: yup
      .string()
      .nullable(false)
      .required('Campo obrigatório')
      .max(100),
    valor: yup
      .number()
      .test('greaterThanTwo', 'Valor deve ser maior do que R$ 2,00', (value) =>
        value ? value > 2 : false
      )
      .max(999999.99, 'Valor não pode exceder R$ 100.000,00')
      .positive('Valor deve ser positivo')
      .required('Campo obrigatório'),
    descricao: yup.string().max(3500).required('Campo obrigatório'),
    vencimento: yup.date(),
    pagadorDocumento: yup
      .string()
      .max(14, 'Documento inválido.')
      .required('Campo obrigatório'),
    pagadorNome: yup.string().max(150).required('Campo obrigatório'),
    pagadorEmail: yup.string().nullable().max(150),
    pagadorTelefone: yup
      .string()
      .min(10, 'Telefone informado inválido')
      .max(11),
    pagadorEndereco: yup
      .string()
      .max(200)
      .required('Campo obrigatório')
      .typeError('Refência externa teste'),
    pagadorBairro: yup.string().max(200).required('Campo obrigatório'),
    pagadorCEP: yup
      .string()
      .max(8, 'CEP inválido')
      .required('Campo obrigatório'),
    pagadorCidade: yup.string().max(50).required('Campo obrigatório'),
    pagadorEstado: yup
      .string()
      .max(2)
      .uppercase()
      .required('Campo obrigatório'),
    sacadorDocumento: yup.string().max(14).required('Campo obrigatório'),
    sacadorNome: yup.string().max(200).required('Campo obrigatório'),
    sacadorCEP: yup.string().max(8, 'CEP inválido').optional(),
  });

  const initialValues = {
    referencia_externa: '',
    valor: '',
    descricao: '',
    vencimento: '',
    pagadorDocumento: '',
    pagadorNome: '',
    pagadorEmail: '',
    pagadorTelefone: '',
    pagadorEndereco: '',
    pagadorBairro: '',
    pagadorCEP: '',
    pagadorCidade: '',
    pagadorEstado: '',
    sacadorDocumento: '',
    sacadorNome: '',
    sacadorCEP: '',
    app: user?.user?.codes?.idClient,
  };

  const onSubmit = async (values) => {
    dispatchRedux.billetServicePost({
      ...values,
    });
    return true;
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ values, submitForm, errors, setFieldValue }) => {
        return (
          <Form onSubmit={submitForm}>
            <Box display="flex" flexDirection="column" gap={4}>
              <Box
                display="grid"
                gridTemplateColumns={{ xs: '1fr', sm: '2fr 1fr 1fr' }}
                gap={4}
              >
                <FieldLabelFormikComponent
                  name="referencia_externa"
                  label="Referencia Externa"
                  size="small"
                />

                <FieldCurrencyComponentDigits
                  name="valor"
                  label="Valor"
                  size="small"
                  customInput={TextFieldLabelComponent}
                />
                <Field name={'vencimento'}>
                  {({
                    form: { setFieldValue },
                    field: { onBlur: fieldOnBlur, ...fieldProp },
                  }) => {
                    return (
                      <Box
                        position="relative"
                        sx={{
                          '.react-datepicker-popper': {
                            zIndex: 99,
                            inset: 'unset !important',
                            top: '0px !important',
                            right: '8px !important',
                          },
                          '.react-datepicker-wrapper': {
                            display: 'flex',
                          },
                        }}
                      >
                        <DatePicker
                          locale={ptBR}
                          dateFormat="dd/MM/yyyy"
                          selected={fieldProp?.value}
                          onChange={(date) => {
                            setFieldValue('vencimento', date);
                          }}
                          customInput={
                            <TextFieldLabel
                              label={'Vencimento'}
                              fullWidth
                              size="small"
                              {...fieldProp}
                            />
                          }
                        />
                      </Box>
                    );
                  }}
                </Field>
              </Box>
              <FieldLabelFormikComponent
                name="descricao"
                label="Descrição do Boleto"
                size="small"
              />
              <Box>
                <Typography>Informaçoes do Pagador</Typography>
                <Box display="flex" flexDirection="column" gap={4}>
                  <Box
                    gap={4}
                    display="grid"
                    gridTemplateColumns={{ xs: '1fr', sm: '2fr 1fr' }}
                  >
                    <FieldLabelFormikComponent
                      name="pagadorNome"
                      label="Nome"
                      size="small"
                    />
                    <FieldDocumentComponent
                      customInput={TextFieldLabelComponent}
                      name="pagadorDocumento"
                      label="Documento"
                      size="small"
                    />
                  </Box>

                  <Box
                    gap={4}
                    display="grid"
                    gridTemplateColumns={{
                      xs: '1fr',
                      sm: '11fr 2fr 8fr 5fr',
                    }}
                  >
                    <FieldLabelFormikComponent
                      name="pagadorEndereco"
                      label="Endereço"
                      size="small"
                    />
                    <FieldLabelFormikComponent
                      name="pagadorNumero"
                      label="Numero"
                      size="small"
                    />
                    <FieldLabelFormikComponent
                      name="pagadorBairro"
                      label="Bairro"
                      size="small"
                    />
                    <FieldPhoneComponent
                      customInput={TextFieldLabelComponent}
                      name="pagadorTelefone"
                      label="DDD + Telefone"
                      size="small"
                    />
                  </Box>

                  <Box
                    gap={4}
                    display="grid"
                    gridTemplateColumns={{
                      xs: '1fr',
                      sm: '1fr 1fr 1fr',
                    }}
                  >
                    <FieldLabelFormikComponent
                      name="pagadorCEP"
                      label="CEP"
                      size="small"
                    />
                    <FieldLabelFormikComponent
                      name="pagadorCidade"
                      label="Cidade"
                      size="small"
                    />
                    <FieldLabelFormik
                      name="pagadorEstado"
                      select
                      size="small"
                      label="Estado"
                      disabled={isBlockedSelect}
                      SelectProps={{
                        native: true,
                      }}
                    >
                      {states?.map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </FieldLabelFormik>
                  </Box>
                </Box>
              </Box>
              <Box>
                <Typography>Informaçoes do Sacador</Typography>
                <Box display="flex" flexDirection="column" gap={4}>
                  <Box
                    gap={4}
                    display="grid"
                    gridTemplateColumns={{ xs: '1fr', sm: '5fr 3fr 2fr' }}
                  >
                    <FieldLabelFormikComponent
                      name="sacadorNome"
                      label="Nome"
                      size="small"
                    />
                    <FieldDocumentComponent
                      customInput={TextFieldLabelComponent}
                      name="sacadorDocumento"
                      label="Documento"
                      size="small"
                    />
                    <FieldLabelFormikComponent
                      name="sacadorCEP"
                      label="CEP"
                      size="small"
                    />
                  </Box>
                </Box>
              </Box>

              <Box
                alignSelf="flex-end"
                gap={2}
                display="flex"
                flexDirection="row"
              >
                <Box display="flex" flexDirection="column" gap={2}>
                  <Box display="flex" gap={2}>
                    <Button
                      id="btn-pay-pinpad"
                      fullWidth
                      loading={selectorRedux.loading}
                      variant="contained"
                      onClick={submitForm}
                      disabled={Object.keys(errors).length > 0}
                    >
                      Gerar Boleto
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
};

const BilletScreen = () => {
  return (
    <Box>
      <FormBillet />
    </Box>
  );
};

export default BilletScreen;
